<svg :width="computedWidth" :height="computedHeight">
  <use :xlink:href="href"></use>
</svg>
